import MenuTop from "../../../../components/menu/top/menu-top";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { fetchUserCompanyService, fetchCompaniesService as getCompanies } from "../../../../features/company/service/company";
import { useNavigate } from "react-router-dom";
import { beneficiaryData } from "../../../../features/beneficiary/forms/beneficiary-data";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { Beneficiary } from "../../../../shared/interfaces/beneficiary";
import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import storage from "../../../../shared/services/storage";
import { fetchBeneficiaryService, updateBeneficiaryService, fetchBeneficiaryTypesService } from "../../../../features/beneficiary/service/beneficiary-service";
import InfoComponent from "../../../../components/info/info";

function BeneficiaryEdit() {
    const { id } = useParams();
    const [ formData, setFormData ] = useState<FormProps[] | any>();
    const { showAlert } = useAlert();
    const [ company, setCompany ] = useState<any>();
    const [ isLoading, setIsLoading ] = useState(true);
    const [ isSubmitting, setIsSubmitting ] = useState(false);
    const navigate = useNavigate();

    const fetchListCompanies = useCallback(async () => {
        try {
            const response = await getCompanies();
            return response?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error("Error fetching companies:", error);
            return [];
        }
    }, []);

    const fetchUserCompany = useCallback(async () => {
        try {
            const userLogged = await storage.getStorage('user');
            if (!userLogged) return null;
            return await fetchUserCompanyService(JSON.parse(userLogged).company.id);
        } catch (error) {
            console.error("Error fetching user company:", error);
            return null;
        }
    }, []);

    const fetchAllData = useCallback(async (beneficiaryId: string) => {
        setIsLoading(true);
        try {
            const response = await fetchBeneficiaryService(beneficiaryId);
            const { ...restResponse } = response;
            
            const [companies, userCompany, beneficiaryTypes] = await Promise.all([
                fetchListCompanies(),
                fetchUserCompany(),
                fetchBeneficiaryTypesService(),
            ]);

            setCompany(userCompany);
    
            const data = beneficiaryData(
                beneficiaryId, 
                restResponse, 
                companies,
                beneficiaryTypes,
                userCompany
            );

            setFormData(data);
        } catch (error) {
            console.error("Error fetching project data:", error);
            showAlert('Erro ao carregar dados do projeto', SEVERITY.ERROR);
        } finally {
            setIsLoading(false);
        }
    }, [fetchListCompanies, fetchUserCompany, showAlert, fetchBeneficiaryTypesService]);
    
    const onSubmitForm = async (data: Beneficiary) => {
        if (isSubmitting) return;
        
        setIsSubmitting(true);
        setIsLoading(true);
        
        try {
            if (company?.name?.toLocaleLowerCase() !== 'causale') {
                data.companyId = company.id;
            }

            await updateBeneficiaryService(id as string, data);

            showAlert('Beneficiário editado com sucesso', SEVERITY.SUCCESS);
            navigate('/beneficiarios', {replace: true});
            
        } catch (error: any) {
            showAlert(
                error.message || 'Erro ao editar beneficiário', 
                SEVERITY.ERROR
            );
        } finally {
            setIsLoading(false);
            setIsSubmitting(false);
        }
    }

    useEffect(() => {
        if (id) { fetchAllData(id)}

    }, [id, fetchAllData]);

    return (
        <div className="container-show-project">
            <MenuTop />
            <InfoComponent />
            <div className="container-show-project__container">
                <Form 
                    data={formData} 
                    title='Editar beneficiário'
                    onSubmitForm={onSubmitForm} 
                    onCancel={() => navigate('/beneficiarios', {replace: true})} 
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
}

export default BeneficiaryEdit;